"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputWithIcon = exports.inputColorHover = exports.inputColorFocused = exports.inputColorReadOnly = exports.inputColorDisabled = exports.inputBase = void 0;

var _stylitas = require("@creditas/stylitas");

const inputBase = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.support(theme)};
  min-width: 100%;
  min-height: 100%;
  border: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  background: transparent;
`;

exports.inputBase = inputBase;

const inputColorDisabled = ({
  theme,
  disabled
}) => disabled && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral05')};
  `;

exports.inputColorDisabled = inputColorDisabled;

const inputColorReadOnly = ({
  theme,
  readOnly
}) => readOnly && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  `;

exports.inputColorReadOnly = inputColorReadOnly;

const inputColorFocused = ({
  theme,
  readOnly
}) => !readOnly && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral09')};
  `;

exports.inputColorFocused = inputColorFocused;

const inputColorHover = ({
  theme,
  inputFocus,
  disabled,
  readOnly
}) => !inputFocus && !disabled && !readOnly && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral08')};
  `;

exports.inputColorHover = inputColorHover;

const inputWithIcon = ({
  variant
}) => variant !== 'default' && (0, _stylitas.css)`
    min-width: calc(100% - 30px);
  `;

exports.inputWithIcon = inputWithIcon;